import React from "react";
import styles from "./style.module.scss";
import Checkbox from "../../../../components/Checkbox/Index";
import Row from "./row";
import useTemplateStore from "../../../../stores/templates";

const Table = ({ data, fetchData }) => {
  const searchFilters = useTemplateStore((state) => state.searchFilters);
  const setSearchFilters = useTemplateStore((state) => state.setSearchFilters);

  const onSortClick = (type) => {
    setSearchFilters({
      ...searchFilters,
      sortBy: type,
      sortColumn: searchFilters.sortColumn == "ASC" ? "DESC" : "ASC",
    });
  };

  return (
    <table className={styles.table}>
      <thead className={styles.tableHead}>
        <tr className={styles.theadRow}>
          <th
            className={`${styles.th} ${styles.w140px}`}
            onClick={() => onSortClick("name")}
          >
            <div className={styles.flex}>
              <span>Name</span>
              {searchFilters?.sortBy == "name" && (
                <span
                  className={`${searchFilters?.sortBy == "name" && searchFilters?.sortColumn == "ASC" ? styles.asc : styles.desc}`}
                >
                  ↑
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th} ${styles.w140px}`}>
            <div className={styles.flex}>
              <span>Owned By</span>
            </div>
          </th>

          <th className={`${styles.th} ${styles.w40px}`}></th>
        </tr>
      </thead>

      <tbody className={styles.tableBody}>
        {data.map((item, index) => (
          <Row key={index} data={item} fetchData={fetchData} />
        ))}
      </tbody>
    </table>
  );
};

export default Table;
